// extracted by mini-css-extract-plugin
module.exports = {"d2xTeaserA":"A_d2xTeaserA__HfRKK"};